/* src/app/components/card-billing-profile/card-billing-profile.component.less */
.container {
  text-align: center;
  padding: 20px;
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.profile-card {
  width: 100%;
  padding: 16px;
  text-align: left;
  border: 1px solid #f5861d;
  box-shadow: 0px 4px 4px 0px #00000040;
  height: auto;
}
.profile-card-info {
  font-size: 14px;
}
.profile-card-info-default {
  text-align: right;
  font-size: 12px;
  color: #f5861d;
  font-weight: 300;
  margin: 0;
}
.profile-card-actions {
  display: flex;
  justify-content: flex-end;
}
mat-icon {
  color: #f5861d;
  cursor: pointer;
}
/*# sourceMappingURL=card-billing-profile.component-BOJ4CHXL.css.map */
